export const timeUTCFilter = (date: Date) => {
  return `${('0' + date.getUTCHours()).slice(-2)}:${(
    '0' + date.getUTCMinutes()
  ).slice(-2)}`
}
